<i [class]="className()" [attr.aria-hidden]="ariaHidden() ? 'true' : null">
  {{ name() }}
</i>
